import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { NodeManagerComponent } from './components/node-management/node-manager/node-manager.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { NodeConfigurationDialogComponent } from './components/node-management/node-configuration-dialog/node-configuration-dialog.component';
import { MibObjectSelectorDialogComponent } from './components/node-management/mib-object-selector-dialog/mib-object-selector-dialog.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { LoadIndicatorComponent } from './components/load-indicator/load-indicator.component';
import { ToastrModule } from 'ngx-toastr';
import { MatInputModule } from '@angular/material/input';
import { NgApexchartsModule } from "ng-apexcharts";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SnmpObjectConfigurationDialogComponent } from './components/node-management/snmp-object-configuration-dialog/snmp-object-configuration-dialog.component';
import { BackupSchedulesComponent } from './components/backups/backup-schedules/backup-schedules.component';
import { ClickStopPropagationDirective } from './directives/click-stop-propagation.directive';
import { CommonModule } from '@angular/common';
import { BackupDevicesComponent } from './components/backups/backup-devices/backup-devices/backup-devices.component';
import { UpdateManagerComponent } from './components/updates/update-manager/update-manager.component';
import { NodeConfigurationMainComponent } from './components/node-management/node-configuration/node-configuration-main/node-configuration-main.component';
import { NodeLifecycleComponent } from './components/node-management/node-lifecycle/node-lifecycle.component';
import { NodeDiagnosisComponent } from "./components/node-management/node-manager/node-diagnosis/node-diagnosis.component";
import { NodeLifecycleParserModalComponent } from './components/node-management/node-lifecycle/node-lifecycle-parser-modal/node-lifecycle-parser-modal.component';
import { NodeLifecycleDetectorModalComponent } from './components/node-management/node-lifecycle/node-lifecycle-detector-modal/node-lifecycle-detector-modal.component';
import { AlertsComponent } from './components/alerts/alerts/alerts.component';
import { DateAgoPipe } from './pipes/date-ago.pipe';
import { NodeHistoryComponent } from './components/node-history/node-history.component';
import { AlertFeaturesModalComponent } from './components/alerts/alert-features-modal/alert-features-modal.component';
import { AuthInterceptor } from './incerteptors/auth.interceptor';
import { ProtectionPoliciesComponent } from './components/protection-policies/protection-policies.component';
import { BlockIpComponentList } from './components/block-ip-list/block-ip-list.component';
import { BlockIpComponent } from './components/block-ip-list/block-ip/block-ip.component';
import { UserManagementComponent } from './components/user-management/user-management.component';
import { UserDialogComponent } from './components/user-management/user-dialog/user-dialog.component';

@NgModule({
    declarations: [
        AppComponent,
        AlertsComponent,
        LoginComponent,
        NodeManagerComponent,
        PaginatorComponent,
        NodeHistoryComponent,
        BackupSchedulesComponent,
        BackupDevicesComponent,
        UpdateManagerComponent,
        DashboardComponent,
        NodeConfigurationDialogComponent,
        NodeConfigurationMainComponent,
        NodeLifecycleComponent,
        MibObjectSelectorDialogComponent,
        LoadIndicatorComponent,
        SnmpObjectConfigurationDialogComponent,
        ClickStopPropagationDirective,
        NodeDiagnosisComponent,
        NodeLifecycleComponent,
        NodeLifecycleParserModalComponent,
        NodeLifecycleDetectorModalComponent,
        AlertFeaturesModalComponent,
        ProtectionPoliciesComponent,
        BlockIpComponentList,
        BlockIpComponent,
        UserManagementComponent,
        UserDialogComponent
    ],
    bootstrap: [AppComponent],
    imports: [
        DateAgoPipe,
        BrowserModule,
        CommonModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        FormsModule,
        MatSidenavModule,
        MatListModule,
        MatDialogModule,
        MatCheckboxModule,
        MatIconModule,
        ReactiveFormsModule,
        MatInputModule,
        MatFormFieldModule,
        MatButtonModule,
        MatSelectModule,
        NgApexchartsModule,
        DragDropModule,
        MatCardModule,
        ToastrModule.forRoot()
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ]
})

export class AppModule { }
